import { onBeforeUnmount, watch, type Ref } from "vue";

export function useRealtime(onChange: (event: MessageEvent) => void, active: Ref<boolean>) {
  let source: EventSource | undefined;
  function stop() {
    source?.close();
    source = undefined;
  }
  function start() {
    stop();
    if (!active.value) return;
    source = new EventSource("/api/stream", { withCredentials: true });
    source.addEventListener("change", event => onChange(event as MessageEvent));
  }
  watch(active, start, { immediate: true });
  onBeforeUnmount(stop);
}
